import { render, staticRenderFns } from "./ViewGroup.vue?vue&type=template&id=29d2d44e&scoped=true&"
import script from "./ViewGroup.vue?vue&type=script&lang=js&"
export * from "./ViewGroup.vue?vue&type=script&lang=js&"
import style0 from "./ViewGroup.vue?vue&type=style&index=0&id=29d2d44e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29d2d44e",
  null
  
)

export default component.exports